import React from 'react';
import { Label } from '../Label';
export const SaintValentinLabel = () => (React.createElement(Label, { icon: "FavoriteFilled", backgroundColor: "pink600", letterSpacing: "normal", fontSize: "10px", padding: "medium" }, "Saint Valentin"));
